<template>
    <div>
        <div class="sticky-quotation-wrapper" id="sticky-quotation-wrapper">
            <b-button
                class="btn btn-success btn-block my-2 sticky-button"
                v-b-modal.customOfferModal_
                >Egyedi ajánlatot kérek
            </b-button>
        </div>
        <b-modal
            id="customOfferModal_"
            title="Egyedi ajánlatot kérek"
            hide-footer
        >
            <h5 v-if="wegotit">
                Oldalsáv kérésedet megkaptuk, hamarosan felvesszük veled a
                kapcsolatot!
            </h5>
            <b-form @submit.prevent="onSubmit" v-else>
                <b-form-group
                    label="Cégnév *"
                    label-for="company_name"
                    :state="customOfferForm.errors.state('company_name')"
                    :invalid-feedback="
                        customOfferForm.errors.get('company_name')
                    "
                >
                    <b-form-input
                        id="company_name"
                        v-model="customOfferForm.data.company_name"
                        :state="customOfferForm.errors.state('company_name')"
                    />
                </b-form-group>

                <b-form-group
                    label="Vezetéknév"
                    label-for="surname"
                    :state="customOfferForm.errors.state('surname')"
                    :invalid-feedback="customOfferForm.errors.get('surname')"
                >
                    <b-form-input
                        id="surname"
                        v-model="customOfferForm.data.surname"
                        :state="customOfferForm.errors.state('surname')"
                    />
                </b-form-group>

                <b-form-group
                    label="Keresztnév"
                    label-for="forename"
                    :state="customOfferForm.errors.state('forename')"
                    :invalid-feedback="customOfferForm.errors.get('forename')"
                >
                    <b-form-input
                        id="name"
                        v-model="customOfferForm.data.forename"
                        :state="customOfferForm.errors.state('forename')"
                    />
                </b-form-group>

                <b-form-group
                    label="Email *"
                    label-for="email"
                    :state="customOfferForm.errors.state('email')"
                    :invalid-feedback="customOfferForm.errors.get('email')"
                >
                    <b-form-input
                        id="email"
                        v-model="customOfferForm.data.email"
                        type="email"
                        :state="customOfferForm.errors.state('email')"
                    />
                </b-form-group>
                <b-form-group
                    label="Mobil telefonszám"
                    label-for="phone"
                    :state="customOfferForm.errors.state('phone')"
                    :invalid-feedback="customOfferForm.errors.get('phone')"
                >
                <b-form-input
                    id="phone"
                    v-model="customOfferForm.data.phone"
                    type="tel"
                    pattern="(\+[0-9]+|[0-9]+)"
                    inputmode="numeric"
                    :state="customOfferForm.errors.state('phone')"
                />
                </b-form-group>

                <b-form-group
                    label="Üzenet"
                    label-for="message"
                    :state="customOfferForm.errors.state('message')"
                    :invalid-feedback="customOfferForm.errors.get('message')"
                >
                    <b-form-textarea
                        id="message"
                        v-model="customOfferForm.data.message"
                        :state="customOfferForm.errors.state('message')"
                        no-resize
                        :rows="5"
                        maxlength="900"
                        @input="msgLen = ($event || '').length"
                    />
                    <small class="text-muted">{{ msgLen }} / 900 karakter</small>
                </b-form-group>

                <p>
                    <small
                        >A küldés gomb megnyomásával elfogadom az Általános
                        Szerződési Feltételeket és az Adatvédelmi
                        nyilatkozatot.</small
                    >
                </p>
                <button
                    type="submit"
                    class="btn mt-3 btn btn-success btn-lg btn-block btn-secondary"
                >
                    <i class="fas fa-paper-plane mr-2"></i>ELKÜLD
                </button>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import VueForm from "~/form/form";
import { trackFormSubmission } from "../services/trackingService";
import { submitToMiniCrm } from "../services/miniCrmService";
import { trackQuotation } from "../services/quotationTrackingService";

@Component
export default class StickyButton extends Vue {
    @Prop(Boolean) userLogged;

    email = "";
    saved = false;
    sent = false;
    wegotit = false;
    msgLen = 0;

    customOfferForm = new VueForm({
        surname: null,
        forename: null,
        company_name: null,
        email: null,
        phone: null,
        email_confirmation: null,
        message: null,
        tax_number: null,
        terms: 1,
        newsletter: 1,
        offer_id: null,
        current_url: window.location.href
    });

    mounted() {
        //this.customOfferForm.data.offer_id = this.lead.id;
        this.customOfferForm.data.current_url = window.location.href;
    }

    async onSubmit() {
        try {
            const lead = await this.customOfferForm.post("/hu/registercta");

            // Run tracking, quotation tracking, and MiniCRM submission in parallel
            await Promise.allSettled([
                trackFormSubmission(
                    "sticky-button-offer",
                    this.customOfferForm.data,
                    {
                        marketing: true,
                        transactionId: `sticky-form-${Date.now()}`,
                        userDataConsent: true
                    }
                ),
                trackQuotation({
                    email: this.customOfferForm.data.email,
                    phone: this.customOfferForm.data.phone,
                    first_name: this.customOfferForm.data.forename,
                    last_name: this.customOfferForm.data.surname,
                    company: this.customOfferForm.data.company_name
                }),
                submitToMiniCrm(
                    "sticky-button-offer",
                    {
                        company_name: this.customOfferForm.data.company_name,
                        first_name: this.customOfferForm.data.forename,
                        last_name: this.customOfferForm.data.surname,
                        email: this.customOfferForm.data.email,
                        phone: this.customOfferForm.data.phone,
                        message: this.customOfferForm.data.message,
                        gdpr: this.customOfferForm.data.terms
                    }
                )
            ]);

            // Only navigate after both tracking and MiniCRM submission are complete
            location.href = "/hu/koszonjuk-ajanlatkeresed";
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    }
}
</script>
<style>
.sticky-quotation-wrapper {
    position: fixed;
    top: 25vh;
    right: 0;
    z-index: 10;
    /* The button is rotated 90deg, but this wrapper's layout box stays the un-rotated
       ~250x64px rectangle at top:25vh right:0 and swallowed clicks on the header/search
       area beside the visible strip. Only the button itself should be clickable. */
    pointer-events: none;
}

.sticky-button {
    font-weight: 600;
    font-size: 1.3rem;
    -webkit-transform: rotate(90deg) translateX(100%);
    transform: rotate(90deg) translateX(100%);
    -webkit-transform-origin: 100% 0%;
    transform-origin: 100% 0%;
    pointer-events: auto;
}

@media only screen and (max-width: 600px) {
    .sticky-quotation-wrapper {
        position: fixed;
        top: inherit;
        bottom: -8px;
        width: 100%;
        right: 0;
        z-index: 1000;
    }

    .sticky-button {
        font-weight: 600;
        font-size: 1.3rem;
        -webkit-transform: rotate(90deg) translateX(100%);
        transform: inherit;
        -webkit-transform-origin: 100% 0%;
        transform-origin: 100% 0%;
    }
}
</style>
